import { FrequencyType } from '@treasury/domain/channel/types/frequency';
import { isValidRepeatOnStart } from '../../utils/frequency';

export const repeatOnDayIsRequired = {
    name: 'Repeat On Day is a required field',
    validate: (val: any) => {
        if (val.type === FrequencyType.OneTime) {
            return true;
        }

        if (val.type === FrequencyType.Weekly) {
            return true;
        }

        if (val.type === FrequencyType.EveryTwoWeeks) {
            return true;
        }

        if (val.type === FrequencyType.TwiceAMonth) {
            return true;
        }

        if (val.type === FrequencyType.Quarterly) {
            return true;
        }

        if (val.type === FrequencyType.EverySixMonths) {
            return true;
        }

        if (val.type === FrequencyType.Yearly) {
            return true;
        }

        return isValidRepeatOnStart(val);
    },
};
